import React from 'react';
import { useLocation } from 'react-router-dom';

import { ContentArea, type ContentAreaTab } from './ContentArea';
import { ROUTES } from '../../constants/routes';

const BILLING_TABS: ContentAreaTab[] = [
  { id: 'reports', label: 'Reports', path: ROUTES.BILLING_REPORTS },
  { id: 'settings', label: 'Settings', path: ROUTES.BILLING_SETTINGS },
  { id: 'manual-payments', label: 'Manual Payments', path: ROUTES.BILLING_MANUAL_PAYMENTS },
  { id: 'plans', label: 'Subscription Plans', path: ROUTES.SUBSCRIPTIONS_PLANS_GYM },
  { id: 'discount-codes', label: 'Discount Codes', path: ROUTES.BILLING_DISCOUNT_CODES },
];

/**
 * Derive active tab from current pathname.
 */
function getActiveTabId(pathname: string): string {
  if (pathname.startsWith(ROUTES.BILLING_REPORTS) || pathname === ROUTES.BILLING) return 'reports';
  if (pathname.startsWith(ROUTES.BILLING_SETTINGS)) return 'settings';
  if (pathname.startsWith(ROUTES.BILLING_MANUAL_PAYMENTS)) return 'manual-payments';
  if (pathname.startsWith(ROUTES.SUBSCRIPTIONS_PLANS_GYM) || pathname.startsWith(ROUTES.SUBSCRIPTIONS_PLANS)) return 'plans';
  if (pathname.startsWith(ROUTES.BILLING_DISCOUNT_CODES) || pathname.startsWith(ROUTES.DISCOUNT_CODES)) return 'discount-codes';
  return 'reports';
}

interface BillingLayoutProps {
  children: React.ReactNode;
}

/**
 * BillingLayout - Wraps billing-related pages with the shared Billing & Subscriptions
 * header and horizontal tabs for navigation between Reports, Settings, Manual Payments,
 * Subscription Plans, and Discount Codes.
 */
export function BillingLayout({ children }: BillingLayoutProps) {
  const location = useLocation();
  const activeTabId = getActiveTabId(location.pathname);

  return (
    <ContentArea
      title="Billing & Subscriptions"
      tabs={BILLING_TABS}
      activeTabId={activeTabId}
    >
      {children}
    </ContentArea>
  );
}
